import _ from "lodash";

export default function checkTimetableMenuType(restaurantDelivery) {
  // console.log("il ristorante menu è", {
  //   restaurantDelivery,
  // });
  let timetableArray = [];
  if (
    restaurantDelivery &&
    restaurantDelivery.menus &&
    restaurantDelivery.menus.length > 0 &&
    restaurantDelivery.menus[0].menu &&
    restaurantDelivery.menus[0].menu.length > 0
  ) {
    restaurantDelivery.menus[0].menu.forEach(item => {
      if (item.timetable) {
        timetableArray.push(...item.timetable);
      } else {
        // timetableArray.push(...item.timetable);
      }
    });
  }
  const timetableArrayUniq = _.uniqBy(timetableArray, "label_it");

  return timetableArrayUniq;
}

export function checkTimetableMenuTypeNew(restaurantDelivery) {
  // console.log("il ristorante menu è", {
  //   restaurantDelivery,
  // });
  let timeTableIds = [];

  if (
    restaurantDelivery &&
    restaurantDelivery.menus &&
    restaurantDelivery.menus.length > 0 &&
    restaurantDelivery.menus[0].menu &&
    restaurantDelivery.menus[0].menu.length > 0
  ) {
    restaurantDelivery.menus[0].menu.forEach(el => {
      el.dishes.forEach(dish => {
        if (dish.timetable && dish.timetable.length > 0) {
          timeTableIds = timeTableIds.concat([]).concat(dish.timetable);
        }
      });
      //   ({
      //   _id: el._id,
      //   label_en: el.title_en,
      //   label_it: el.title_it,
      //   from: `${el.hourFrom}:${el.minuteFrom}`,
      //   to: `${el.hourTo}:${el.minuteTo}`
      // }));
    });
  }
  const timetableArrayUniqIds = _.uniq(timeTableIds);

  // // PROBABILMENTE NON SERVE A NULLA
  // const timetableArrayUniq = _.uniqBy(timetableArray, "_id");
  const timetableArrayUniq = timetableArrayUniqIds.map(el => {
    const findTimeTable =
      restaurantDelivery &&
      restaurantDelivery.menus[0].timetable.find(time => {
        return time._id === el;
      });
    if (findTimeTable) {
      return {
        _id: findTimeTable._id,
        label_en: findTimeTable.title_en,
        label_it: findTimeTable.title_it,
        from: `${findTimeTable.hourFrom}:${findTimeTable.minuteFrom}`,
        to: `${findTimeTable.hourTo}:${findTimeTable.minuteTo}`
      };
    }
    return null;
  });

  return timetableArrayUniq.filter(Boolean);
}
